function check() {
    if (!navigator.cookieEnabled)
        return false;
    if (window.self !== window.top) {
        var cookie = 'thirdparty.check=' + Math.round(Math.random() * 1000);
        document.cookie = cookie + '; path=/';
        return document.cookie.indexOf(cookie) !== -1;
    }
    return true;
}

export function setCookie(key: string, value: string, expireDays: number | null = null, domain: string = '') {
    if (check() === false) {
        throw Error('cookies are disabled');
    }
    let cookie = `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    if (expireDays !== null) {
        let date = new Date();
        date.setTime(date.getTime() + (expireDays * 24 * 60 * 60 * 1000));
        cookie += `; expires=${date.toUTCString()}`;
    }
    if (domain !== '') {
        cookie += `; domain=${domain}`;
    }
    cookie += `; secure; path=/`;
    document.cookie = cookie;
}

export function getCookie(key: string) {
    if (check() === false) {
        throw Error('cookies are disabled');
    }
    let encodedKey = encodeURIComponent(key);
    let cookies = document.cookie ? document.cookie.split(';') : [];
    for (let i = cookies.length - 1, cookie; i >= 0; i--) {
        cookie = cookies[i].replace(/^\s*/, '');
        if (cookie.indexOf(encodedKey + '=') === 0) {
            return decodeURIComponent(cookie.substring(encodedKey.length + 1, cookie.length));
        }
    }
    return null;
}

export function removeCookie(key: string) {
    setCookie(key, '', -1);
    let domainParts = document.domain.split('.');
    for (let i = domainParts.length; i >= 0; i--) {
        setCookie(key, '', -1, `.${domainParts.slice(- i).join('.')}`);
    }
}

export function isCookieSet(key: string) {
    return getCookie(key) !== null;
}
